/**
 * Display config for the Library asset cards. Cards are data-driven - they render
 * whatever tags a file carries - but the metadata line and status badge surface a
 * curated subset of axes in a fixed order. Nothing here is required: an axis with
 * no tag on a file simply renders nothing (the card degrades gracefully), and the
 * codes live here (not inline in the component) so the curated set is configured
 * in one place, alongside the upload panel's `classify-config.ts`.
 */

/** Axis codes whose tags compose the card's metadata line, in display order (region · file_type). */
export const CARD_METADATA_AXES = ['geography', 'asset_type']

/** Axis code whose tag renders as the card's status badge (workflow state). */
export const CARD_STATUS_AXIS = 'lifecycle'
